import { motion } from "framer-motion";
import { Reveal, Overline, EASE } from "./motion";
import { useT } from "@/i18n/LangContext";

const TEAM_IMG = "/images/team.jpg";

const WRAPS = [
  "md:col-span-6",
  "md:col-span-5 md:col-start-8",
  "md:col-span-5",
  "md:col-span-6 md:col-start-7",
];

export default function Manifesto() {
  const t = useT();

  return (
    <section id="approach" data-testid="approach-section" className="bg-lav py-20 md:py-40">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <Reveal className="mb-16 md:mb-24">
          <Overline testId="approach-overline">{t.approach.overline}</Overline>
          <h2
            data-testid="approach-heading"
            className="mt-6 max-w-3xl font-serif text-4xl font-light leading-tight tracking-tight text-ink md:text-5xl"
          >
            {t.approach.heading}
          </h2>
          <p className="mt-5 text-sm font-medium uppercase tracking-[0.25em] text-ink/75">
            {t.approach.sub}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-y-16 md:grid-cols-12 md:gap-x-8 md:gap-y-32">
          {t.approach.chapters.map((c, i) => (
            <Reveal key={c.n} delay={0.05 * i} className={WRAPS[i]}>
              <div data-testid={`chapter-${c.n}`} className="border-t border-ink/15 pt-8">
                <span className="font-serif text-6xl font-medium text-ink md:text-7xl">
                  {c.n}
                </span>
                <span className="mt-4 block h-1.5 w-14 rounded-full bg-bee" aria-hidden="true" />
                <h3 className="mt-6 font-serif text-2xl font-normal tracking-tight text-ink md:text-3xl">
                  {c.title}
                </h3>
                <p className="mt-4 max-w-md text-base font-light leading-relaxed text-ink/85">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}

          <motion.div
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            whileInView={{ clipPath: "inset(0 0 0% 0)" }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, ease: EASE }}
            className="md:col-span-4 md:col-start-2 md:-mt-24"
            data-testid="approach-image"
          >
            <img
              src={TEAM_IMG}
              alt={t.approach.imgAlt}
              className="aspect-[4/3] w-full border border-lavline object-cover"
              loading="lazy"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
